export const ScreenChange = (data) => ({
    type: 'ScreenChange',
    data: data
});

export const ScreenFull = (full = false) => ({
    type: 'ScreenFull',
    data: {full: full}
});
